
export const DAYS = 24 * 60 * 60 * 1000;
